import React, { useState } from "react";
import axios from "axios";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogDescription,
} from "./ui/dialog";
import { Input } from "./ui/input";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NewsletterDialog = ({ trigger }) => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const valid = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
    if (!valid) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/newsletter/subscribe`, { email });
      if (res.data.already_subscribed) {
        toast("You\u2019re already on the list \u2014 thanks!");
      } else {
        toast.success("You\u2019re in. Welcome to the decade of becoming.");
      }
      setEmail("");
      setOpen(false);
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="bg-[#eceae5] max-w-md border-neutral-300">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl text-neutral-900" style={{ fontWeight: 700 }}>
            Join the newsletter
          </DialogTitle>
          <DialogDescription className="font-display italic text-neutral-600 text-base">
            Stories, episodes, and small nudges for your 20s. No spam, ever.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="mt-4 flex flex-col gap-4">
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@email.com"
            className="h-12 bg-white/70 border-neutral-300 font-sans-ui focus-visible:ring-neutral-900"
          />
          <button
            type="submit"
            disabled={loading}
            className="bg-neutral-900 hover:bg-neutral-700 disabled:opacity-60 text-white font-sans-ui py-4 rounded-full transition-colors"
          >
            {loading ? "Subscribing\u2026" : "Subscribe"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default NewsletterDialog;
